console.log('Hi from multicol-modal')

const openers =  document.querySelectorAll('.multicolumn-card__info')
const closers = document.querySelectorAll('.multicolumn-modal_quit')
const modals = document.querySelectorAll('.multicolumn_modal');

// ouvrir la modal
function ouvrirModal(index) {
  modals[index].style.display = 'block';
}

// fermer la modal
function fermerModal(index) {
  modals[index].style.display = 'none';
}

// événements ouverture
openers.forEach((bouton, index) => {
    console.log('openers')
  bouton.addEventListener('click', () => ouvrirModal(index));
});

// événements fermeture
closers.forEach((bouton, index) => {
  bouton.addEventListener('click', () => fermerModal(index));
});

// fermeture modal si clique en dehors
modals.forEach((modal, index) => {
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      fermerModal(index);
    }
  });
});
